export default __webpack_public_path__ + "static/media/QueenieLovelace.0995c1c3.png";